import { ErrorHandler } from '@angular/core';
import { GlitchtipService } from 'src/app/common/glitchtip/glitchtip.service';
import { environment } from 'src/environments/environment';

export class SharryErrorHandler implements ErrorHandler {
  constructor(private glithctipService: GlitchtipService) {}
  handleError(error: Error) {
    const chunkFailedMessage = /ChunkLoadError:\sLoading\schunk\s.+\sfailed/;
    if (chunkFailedMessage.test(error.message) && typeof window !== 'undefined') {
      window.location.reload();
    } else {
      if (environment.production) {
        this.glithctipService.captureMessage(error);
      }
      console.error('-------------\n', `Date: ${new Date().toISOString()}\n`, error, '\n-------------');
    }
  }
}
